'use client';

import { c as _c } from "react/compiler-runtime";
import 'jotai-devtools/styles.css';
import { Provider, useAtomValue } from 'jotai';
import { DevTools } from 'jotai-devtools';
import { atomWithStorage } from 'jotai/utils';
import dynamic from 'next/dynamic';
import { Fragment } from 'react';
import { Body } from '@/app/[locale]/_components/BodyProvider';
import { myStore } from '@/atoms/store';
import { isServer, omitUndefined } from '@sub-vocab/utils/lib';
const StyleComponent = dynamic(() => import('./devtools-styles'));
const jotaiDevtoolsIsShellOpenAtom = atomWithStorage(`jotai-devtools-is-shell-open-V0`, false, undefined, {
  getOnInit: true
});
jotaiDevtoolsIsShellOpenAtom.debugLabel = 'jotaiDevtoolsIsShellOpenAtom';
export const JotaiProvider = t0 => {
  const $ = _c(6);
  const {
    children
  } = t0;
  const store = isServer ? undefined : myStore;
  const jotaiDevtoolsIsShellOpen = useAtomValue(jotaiDevtoolsIsShellOpenAtom);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = omitUndefined({
      store
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== jotaiDevtoolsIsShellOpen) {
    t2 = process.env.NODE_ENV !== "production" ? <Fragment><StyleComponent /><DevTools store={store} isInitialOpen={jotaiDevtoolsIsShellOpen} /></Fragment> : null;
    $[1] = jotaiDevtoolsIsShellOpen;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t2) {
    t3 = <Provider {...t1}><Body>{t2}{children}</Body></Provider>;
    $[3] = children;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};